import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'sz-day-strip',
  templateUrl: './sz-day-strip.component.html',
  styleUrls: ['./sz-day-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzDayStripComponent {
  readonly days: InputSignal<ReadonlyArray<boolean>> = input.required<ReadonlyArray<boolean>>();
  readonly startLabel: InputSignal<string | null> = input<string | null>(null);
  readonly endLabel: InputSignal<string | null> = input<string | null>(null);
}
